module.exports = __webpack_public_path__ + "media/images/sites/health/luciano-4f49d9f065716f87bde691e69b35c1e9.jpg";